import React from 'react';
import { Radiobutton } from 'components/forms';

const RadiobuttonWrapper: React.FC<any> = (props) => {
  const { input, meta, render, children, onChangeAddOn, ...otherProps } = props;
  return <Radiobutton {...input} {...otherProps} onChangeAddOn={onChangeAddOn} />;
};

export default RadiobuttonWrapper;
